<template>
  <div class="uk-container uk-flex uk-flex-center uk-flex-middle" uk-height-viewport>
    <div class="uk-card uk-card-default">
      <div class="uk-card-header">
        <div class="uk-margin-top uk-margin-bottom">
          <img src="/img/esen-inan-logo.svg" width="170" uk-img>
        </div>
        <div class="uk-card-title">Online Seviye Belirleme Sınavı</div>
        <div class="uk-card-body">
          <div class="uk-alert uk-alert-success" v-if="success != null">
            <span uk-icon="icon: check; ratio: 2"></span>
            <p v-text="success"></p>
          </div>
          <div class="uk-alert uk-alert-danger uk-text-center" v-if="error != null">
            <span uk-icon="icon: warning; ratio: 2"></span>
            <p v-text="error"></p>
          </div>
          <div v-if="success === null">
            <div class="uk-margin">
              <input type="text" class="uk-input" placeholder="Ad" v-model="name" />
            </div>
            <div class="uk-margin">
              <input type="text" class="uk-input" placeholder="Soyad" v-model="surname" />
            </div>
            <div class="uk-margin">
              <input type="text" class="uk-input" placeholder="E-Posta" v-model="email" />
            </div>
            <div class="uk-margin">
              <input type="text" class="uk-input" placeholder="Telefon" v-model="phone" />
            </div>
            <div class="uk-width-1-1 checkbox-group uk-text-left checkboxStyle">
              <div class="uk-form-controls">
                <label>
                  <input class="uk-checkbox" type="checkbox" v-model="kvkk">
                  <a href="#kvkk-modal" uk-toggle> Esen İnan tarafından aydınlatma metnini okudum, kişisel verilerimin işlenmesine rıza gösteriyorum.</a>
                </label>
                <br><br>
                <label>
                  <input class="uk-checkbox" type="checkbox" name="checkbox2" v-model="etk">
                  Esen İnan tarafından iletişim bilgilerim kaydedilerek ürün, hizmet ve kampanyalarla ilgili reklam, pazarlama ve bilgi amaçlı SMS, e-posta dahil olmak üzere her türlü ticari elektronik ileti gönderilmesini ve diğer iletişim araçları kullanılarak tarafımla iletişime geçilmesine izin veriyorum.”                                    </label>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-card-footer" v-if="success === null">
          <button class="uk-button uk-button-primary" @click="signUp()">Başvur</button>
        </div>
      </div>
      <KvkkModal />
    </div>
  </div>
</template>
<script>
import KvkkModal from "@/components/KvkkModal";
import Axios from "axios";
export default {
  name: "SignUp",
  components:{
    KvkkModal
  },
  data(){
    return{
      name : null,
      surname : null,
      email : null,
      phone : null,
      kvkk : false,
      etk : false,
      success : null,
      error : null
    }
  },
  methods:{
    signUp(){
      var postData = JSON.stringify({
          name : this.name,
          surname : this.surname,
          email : this.email,
          phone : this.phone,
          kvkk : this.kvkk,
          etk : this.etk
        });
      Axios.post("https://bsapp.dev/QuizApp/api/signUp",postData)
      .then(response => {
        // console.log(response.data)
        this.success = response.data.success,
        this.error = response.data.error
      })
      .catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
  .checkboxStyle{
    font-size: 11px;
  }
  .checkboxStyle a,
  .checkboxStyle a:visited,
  .checkboxStyle a:hover,
  .checkboxStyle a:focus{
    color: #666666;
  }
</style>